import { DropdownItem } from 'cargo-chief-commons';

import { environment } from '@environment/environment';

import { CANADA_PROVINCES } from './canada-provinces';
import { MEXICAN_STATES } from './mexican-states';
import { USA_STATES } from './usa-states';

// Each country behind its own flag, mirroring carriers-loads-list's searchableOriginStates.
export const FILTERABLE_STATES = (): Array<DropdownItem> => {
	const states = [...USA_STATES];
	if (environment.FEATURE_FLAGS.CANADA_ENABLED) {
		states.push(...CANADA_PROVINCES);
	}
	if (environment.FEATURE_FLAGS.MEXICO_ENABLED) {
		states.push(...MEXICAN_STATES);
	}
	return states;
};
